module.exports = __webpack_public_path__ + "static/media/gav.ab775947.png";